export const COACH_LEVELS = {
  AWAITING_REVIEW: '1',
  AWAITING_ACQUIRED_CLIENT: '2',
  ACQUIRED_CLIENT_TRIAL: '3',
  MARKETPLACE_CLIENT_TRIAL: '4',
  BRONZE: '5',
  SILVER: '6',
  GOLD: '7',
  PLATINUM: '8',
  PROBATION: '9',
  INACTIVE: '10',
  DIAMOND: '11',
}
